export default __webpack_public_path__ + "static/media/Add2.2ded2bcf.svg";